import { Link } from "@tblabs/truffle";


export class HashLink extends Link
{
    constructor(label: string, url?: string)
    {
        super(label, url ? "#" + url : "");

        this.Class("hash-link")
    }
}
